<template>
    <client-page class=" wrap--products">
        <div class="container">
            <h2 class="join-title">회원가입</h2>

            <div class="join-container">
                <!-- 가입 단계 표시 -->
                <nav class="join-step">
                    <ul class="join-step-lists">
                        <li class="list list--on">
                            <span class="badge">STEP 1</span>
                            <span class="text">약관동의</span>
                        </li>
                        <li class="list">
                            <span class="badge">STEP 2</span>
                            <span class="text">정보입력</span>
                        </li>
                        <li class="list">
                            <span class="badge">STEP 3</span>
                            <span class="text">가입완료</span>
                        </li>
                    </ul>
                </nav>

                <!-- 약관동의 -->
                <terms-of-agreements ref="terms" :code="$route.query.code" />

                <!-- 하단버튼 -->
                <div class="bottom-button">
                    <div class="v-btn--group v-btn--group--large">
                        <v-btn x-large outlined color="grey-cb" class="w-100 mw-220px" @click="$router.go(-1)"><span class="primary--text">취소하기</span></v-btn>
                        <v-btn x-large color="primary" class="w-100 mw-220px" @click="submit">계속 진행</v-btn>
                    </div>
                </div>
            </div>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TermsOfAgreements from "@/components/client/join/terms-of-agreements.vue";

export default {
    components: {
        ClientPage,
        TermsOfAgreements,
    },
    methods: {
        submit() {
            try {
                if (this.$refs.terms.check()) {
                    this.$store.dispatch("agreements", this.$refs.terms.selected);

                    this.$router.push({
                        path: "/join/form",
                        query: this.$route.query,
                    });
                }
            } catch (error) {
                alert(error.message.toString());
            }
        },
    },
};
</script>
